import React, { useContext, useEffect } from 'react'
import { authContext } from '../../Login/AuthContext';
import Checkboxs from './Checkbox'
import {Chart as ChartJS,defaults,CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import {PlotLine3var, PlotBar3var, getColData} from "../config.js"
import VentilationTable from './VentilationTable';
import AsyncCSV from '../../config/ExportCSV'
import axios from "axios";

ChartJS.register(CategoryScale);
ChartJS.register(LinearScale);
ChartJS.register(BarElement);
ChartJS.register(Title);
ChartJS.register(Tooltip);
ChartJS.register(Legend);

/*  eslint eqeqeq: 0 */

var title = "Ventilation par type d'établissement";

var headerVentilationTable = [
  {label:"zone", key:"zone"},
  {label:"categorie", key:"categorie"},
  {label:"type", key:"type"}
];

global.years.map((elem, i) => {
  headerVentilationTable[headerVentilationTable.length] = {label:"nbHotel"+elem, key:"nbHotel"+elem}
  headerVentilationTable[headerVentilationTable.length] = {label:"nbCheckin"+elem, key:"for"+elem}
  headerVentilationTable[headerVentilationTable.length] = {label:"nbNights"+elem, key:"for"+elem+"Nights"}
})

var headerVentilationCategories = [
    {label:"year", key:"year"},
    {label:"month", key:"month"},
    {label:"category", key:"category"},
    {label:"total", key:"nb"},
    {label:"fr", key:"fr"},
    {label:"es", key:"es"},
    {label:"nl", key:"nl"},
    {label:"de", key:"de"},
    {label:"be", key:"be"},
    {label:"gb", key:"gb"},
    {label:"us", key:"us"},
    {label:"it", key:"it"},
    {label:"pt", key:"pt"},
    {label:"sw", key:"sw"},
  ]

var dataCSV;

const VentilationTypes = () => {
  const { auth } = useContext(authContext);
  useEffect(() => {//componentDidMount() {
    if(auth.data){
      dataCSV = auth.data;
      if(!dataCSV.dataCSV)
        dataCSV.dataCSV = [];
      if(!dataCSV.dataCSV["VentilationCategories"])
        dataCSV.dataCSV["VentilationCategories"] = [];
      updateVentilationTypes(auth.data.zone, auth.data.token);
      auth.data = dataCSV
    }
  }, [auth.data])

  return (
      <div className="xl-container">
        <div className="alert alert-primary" role="alert">{title} -
          <AsyncCSV name={auth.data.zone.name+"_Ventilation"} header={headerVentilationTable} dataCSV="Ventilation"/></div>
        <Checkboxs/>
        <VentilationTable zone={auth.data.zone} i={1} full={true}/>
        <br/>
        <AsyncCSV name={auth.data.zone.name+"_VentilationCategories"} header={headerVentilationCategories} dataCSV="VentilationCategories"/>
      </div>
    )
}
export default VentilationTypes;

function updateVentilationTypes (zone, token){
  fetch("https://mel.dvrc.fr/api/GetBookingDataByAccommodationFromShapeGID36.php?shape_gid="+zone.shapes+"&years="+global.years+"&token="+token)
      .then(res => res.json())
      .then( (data) => {
        //var itemNames=Object.keys(data[0]);
        var tab = [];
        tab[0] = {"title":"Categories", "values":[]}
        var varTemp, tmp;
        for(var j=0; j<data.length-1; j++)
        {
          var itemValues=Object.values(data[j]);
          if(varTemp != itemValues[0]){
            if(tmp!=undefined)
              tab[0]["values"].push(tmp);
            tmp = {"name":itemValues[0], "nb":1}
            varTemp = itemValues[0];
          } else{
            tmp["nb"]++;
          }
        }
        tab[0]["values"].push(tmp);

        if(!tab[0] || !tab[0]["values"])
          return ;

        for(var k=0;k<tab[0]["values"].length;k++) {
            if(tab[0]["values"][k])
              TopByCategorie(k,zone.shapes,tab[0]["values"][k]["name"], token);
        }
  });
}

async function TopByCategorie(k,shapeGID,categorie, token){
  /*
  const[data_0, data_1, data_2] = await Promise.all([
      fetch('https://mel.dvrc.fr/api/GetBookingDataYearTop10ByAccommodation36.php?shape_gid=' + shapeGID + '&year='+global.years[0]+'&cat=' + categorie+"&token="+token).then(res => res.json()),
      fetch('https://mel.dvrc.fr/api/GetBookingDataYearTop10ByAccommodation36.php?shape_gid=' + shapeGID + '&year='+global.years[1]+'&cat=' + categorie+"&token="+token).then(res => res.json()),
      fetch('https://mel.dvrc.fr/api/GetBookingDataYearTop10ByAccommodation36.php?shape_gid=' + shapeGID + '&year='+global.years[2]+'&cat=' + categorie+"&token="+token).then(res => res.json()),
    ]);
  */
  var datas = []
  global.years.map(
    async (elem, i) => {
      const [data] = await Promise.all([
        fetch('https://mel.dvrc.fr/api/GetBookingDataYearTop10ByAccommodation36.php?shape_gid=' + shapeGID + '&year='+elem+'&cat=' + categorie+"&token="+token).then(res => res.json())
      ])
      datas[i] = data
      toCSV(data, elem, categorie);
      TopByCategorieShow(datas, k, categorie, shapeGID, token)
    }
  )
}
/*
    var data0 = data_0;
    var data1 = data_1;
    var data2 = data_2;
    toCSV(data_0, global.years[0], categorie);
    toCSV(data_1, global.years[1], categorie);
    toCSV(data_2, global.years[2], categorie);
*/
function TopByCategorieShow(datas, k, categorie, shapeGID, token){
  if(datas.length == global.years.length){
      if(!document.getElementById("rep" + k + ""))
        return ;


      var canvas = ''
      var l=0
      var width=100/global.years.length
      for(l=0;l<global.years.length;l++){
        canvas += '<div class="col"><canvas id="dataTop'+l+'_' + k + '" width="'+width+'%" height="20px"></canvas><center>'+global.years[l]+'</center></div>'
      }

      document.getElementById("rep" + k + "").innerHTML =
            '<div class="alert alert-primary" role="alert" id="type_'+categorie+'">' +
              '<b>Categorie : ' + categorie + '</b> - Ventilation par type d\'établissement et nationalité' +
            '</div>' +
            '<div id="type_details_'+k+'" class="type_details">'+
              '<button id="' + k + 'B" type="button" class="btn btn-primary btn-sm">Dynamic scale</button> ' +
              '<div class="row">' + canvas +
              '</div><button id="button_' + k + '" type="button" class="btn btn-primary btn-sm">Show details</button>' +
              '<div class="topdetails" id="topdetail' + k + '"></div>'+
            '</div><hr/><BR>';

            document.getElementById('button_'+k).addEventListener('click', function () {
              if(!global.topdetails)
                global.topdetails = [];
              global.topdetails[k] = !global.topdetails[k];
              document.getElementById('topdetail'+k).style.display = (global.topdetails[k]?"block":"none");
            });
        var dataJSON = Array()
        var max = 0
        for(l=0;l<datas.length;l++){
            dataJSON[l] = ConvertTopToJson(datas[l]);
            var max_l = GetMax(datas[l]);
            if(max_l > max)
              max = max_l
            if(!lesPays)
                var lesPays = GetLabelPayTop(datas[l]);
        }

        for(l=0;l<dataJSON.length;l++){
          canvas = 'dataTop'+l+'_' + k
          DrawTop(dataJSON[l], canvas, global.years[l], k, true, max);
        }

        detailByCategorieTop(shapeGID, lesPays, categorie, k, token);
    }
    else
    {
        if(document.getElementById("rep" + k + ""))
          document.getElementById("rep" + k + "").innerHTML =
        '<div class="alert alert-primary" role="alert">\n' +
            '<b>Categorie : ' + categorie + '</b> - Ventilation par type d\'hébergement et nationalité' +
          '</div>' +
          '<div class="row">Data not complete</div>' +
          '<div class="container" id="topdetail' + k + '"></div><hr/><BR>';
    }

}

function detailByCategorieTop(shapegid,pays,categorie,k, token)
{
    fetch("https://mel.dvrc.fr/api/GetBookingDataYearTabCountryByAccommodation36.php?shape_gid="+shapegid+"&country="+pays+"&cat="+categorie+"&token="+token)
        .then(res => res.json())
        .then( (data) => {
        var itemNames=Object.keys(data[0]);

        var PaysToPlot =(Object.keys(data[0]).length-7)/6;

        var i=0;

        var PaysName=[];
        while(i<PaysToPlot)
        {
            var tempName=itemNames[7+i*6].substring(itemNames[7+i*6].length-2);
            i++;
            PaysName.push(tempName);
        }

        var htmlCodeDiv ='<div class="alert alert-primary" role="alert">\n' +
            '        ' + categorie + ' - Top 5 Details' +
            '    </div>\n';

        for(i=0; i<PaysName.length;i++)
        {
            htmlCodeDiv=htmlCodeDiv+'    <div class="row">\n' +
                '        <div class="col">\n' +
                '            <canvas id="topdet'+k+'_1'+PaysName[i]+'" width="200px" height="150px"></canvas>' +
                '<button id="topdet'+k+'_1'+PaysName[i]+'B" type="button" class="btn btn-primary btn-sm">Dynamic scale</button>'+
                '        </div>\n' +
                '        <div class="col">\n' +
                '            <canvas id="topdet'+k+'_2'+PaysName[i]+'" width="200px" height="150px"></canvas>\n' +
                '        </div>\n' +
                '    </div>';
        }
        htmlCodeDiv=htmlCodeDiv+ '    </div>';
        if(!document.getElementById('topdetail'+k))
          return;
        document.getElementById('topdetail'+k).innerHTML = htmlCodeDiv;

        for(i=0;i<PaysName.length;i++) {
            var indicePays = i;
            var decal = indicePays * 6;
            var pays2018 = GetRatioCol(data, 0, 1, 7 + decal);
            var pays2019 = GetRatioCol(data, 0, 3, 7 + decal + 2);
            var pays2020 = GetRatioCol(data, 0, 5, 7 + decal + 4);

            var pays2018Ab = getColData(data, 0, 7 + decal);
            var pays2019Ab = getColData(data, 0, 7 + decal + 2);
            var pays2020Ab = getColData(data, 0, 7 + decal + 4);

            PlotLine3var('topdet' + k + '_1' + PaysName[indicePays], pays2018, pays2019, pays2020, PaysName[indicePays], ['2018', '2019', '2020'], true);
            PlotBar3var('topdet' + k + '_2' + PaysName[indicePays], pays2018Ab, pays2019Ab, pays2020Ab, PaysName[indicePays], ['2018', '2019', '2020']);
        }
    });
}

function DrawTop(data,ElementDisplay,title,k,button=false,max){
        var monthText = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        var ctx = document.getElementById(ElementDisplay);
        var myChart = new ChartJS(ctx, {
            type: 'bar',

            data: {
                labels: monthText,
                datasets: data
            },
            options: {
                title: {
                    display: true,
                    text: title
                }
            }
        });

        var echelle=0;
        if(button) {
            document.getElementById(k + 'B').addEventListener('click', function () {
                if (echelle === 0) {
                    myChart.options.scales.yAxes[0].ticks.min = 0;
                    myChart.options.scales.yAxes[0].ticks.max = max;
                    echelle=1;
                    document.getElementById(k+ 'B').firstChild.data  = "Fixed scale";
                } else {

                    myChart.options.scales.yAxes[0].ticks.min = myChart.options.scales.yAxes[0].ticks.suggestedMin;
                    myChart.options.scales.yAxes[0].ticks.max = myChart.options.scales.yAxes[0].ticks.suggestedMax;
                    document.getElementById(k + 'B').firstChild.data  = "Dynamic scale"
                    echelle=0;
                }

                myChart.update();
            });
        }
    }

function ConvertTopToJson(data){
  if(!data || !data[0])
    return;
  var resJSON=[];
  var i;
  for(var j=2 ; j<Object.values(data[0]).length;j++)
  {
        var temp19 = new Array(12);
        for (i = 0; i < temp19.length; i++) {
            temp19[i] = null;
        }
        var colDet = j;
        for (i = 0; i < data.length; i++) {
            temp19[Object.values(data[i])[0] - 1] = Object.values(data[i])[colDet];
        }
        var labelData = Object.keys(data[0])[colDet];
        //var dataCountrie = temp19;
        var lineData = '{"label":"' + labelData + '","backgroundColor" : "'+global.palette6col[j-2]+'","data":' + JSON.stringify(temp19) + '}';
        resJSON.push(lineData);
    }

    var dataAConvertir="[";
    for (i=0; i<resJSON.length;i++)
    {
        if (i===resJSON.length-1)
        {
            dataAConvertir+=resJSON[i]+']';
        } else
            dataAConvertir+=resJSON[i]+',';
    }

    var dataJSON=JSON.parse(dataAConvertir);

    return dataJSON;
}

function GetLabelPayTop(data){
  if(!data || !data[0])
    return;
  var resJSON=[];

  for(var j=2 ; j<Object.values(data[0]).length;j++)
  {
        var labelData = Object.keys(data[0])[j];
        resJSON.push(labelData);
  }


    return JSON.stringify(resJSON);
}

function GetMax(data){
    var max=0;
    if(!data)
      return
    for (var i = 0; i < data.length; i++)
        {

            var ligne = Object.values(data[i]);

            for(var j=2;j<ligne.length; j++)
            {
                var value=parseInt(ligne[j],10);

                if (value>max)
                    max=value;
            }
        }

    return max;
}

function GetRatioCol(data,colMonth,ColTotal,ColPays){
    var tempMonth = new Array(12);
    for (var i = 0; i < tempMonth.length; i++)
        tempMonth[i] = null;
    for (i = 0; i < data.length; i++)
        tempMonth[Object.values(data[i])[colMonth] - 1] = Object.values(data[i])[ColPays]/Object.values(data[i])[ColTotal];
    return tempMonth;
}

function toCSV (data, year, category) {

    for(var j=0;j<data.length;j++){
      var d = {year:year, category:category}
      Object.assign(d, data[j])
      
        var found = 0;
        for(var i=0; i<dataCSV.dataCSV["VentilationCategories"].length;i++){
            if(dataCSV.dataCSV["VentilationCategories"][i].year == d.year && dataCSV.dataCSV["VentilationCategories"][i].month == d.month && dataCSV.dataCSV["VentilationCategories"][i].category == d.category)
                found = 1;
        }
        
        if(!found)
            dataCSV.dataCSV["VentilationCategories"].push(d)
    }
  }
